<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.market.purposeTitle') }}</span>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-6">
                    <v-col cols="12">
                        <v-row justify="center">
                            <v-radio-group v-model="intentionData.intention" :mandatory="false">
                                <v-radio label="高意向" value="2"></v-radio>
                                <v-radio label="低意向" value="1"></v-radio>
                                <v-radio label="无意向" value="0"></v-radio>
                            </v-radio-group>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-row>
                    <v-col cols="6">
                        <v-btn color="error" dark @click="hiddenDialog">{{
                                $vuetify.lang.t('$vuetify.custom.cancelBtn')
                            }}
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn color="success" dark @click="updateIntention">{{ $vuetify.lang.t('$vuetify.custom.okBtn') }}</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>
export default {
    name: 'mark-purpose',
    model: {
        prop: 'purposeDialog',
        event: 'parent-event'
    },
    props: {
        intentionData:Object,
        purposeDialog: Boolean
    },
    mounted() {
    },
    data: () => ({
    }),
    watch: {},
    methods: {
        updateIntention(){
            this.$api.clew.updateIntentionByClewId(this.intentionData).then(data => {
                if (data.flag) {
                    this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.updateSuccess'));
                    this.$emit('initBaseMsg')
                    this.hiddenDialog();
                } else {
                    this.$dialog.alert(data.msg)
                }
            })
        },
        hiddenDialog() {
            this.$emit('parent-event', false);
        },
    },
}
</script>
